import script from "./LocationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./LocationForm.vue?vue&type=script&setup=true&lang=js"

import "./LocationForm.vue?vue&type=style&index=0&id=fe895eb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe895eb6"]])

export default __exports__